// extracted by mini-css-extract-plugin
export default {"spinner":"ButtonLoadingSpinner_spinner__GGvSS"};